module.exports = __webpack_public_path__ + "img/04-B09.ab65dea4.png";